import { generateText as generateTextAi, streamText as streamTextAi } from 'ai'
import { aiModelsSchema, getAIModel, stripUnsupportedSamplingParams } from './schema/providers.js'

type GenerateText = Omit<Parameters<typeof generateTextAi>[0], 'model'> & {
  type: 'client' | 'server'
  apiKey: string
  modelName: string
}

/** Thin wrapper around AI SDK generate text  */
export const generateText = ({
  apiKey,
  modelName,
  type = 'server',
  messages = [],
  ...restProps
}: GenerateText): ReturnType<typeof generateTextAi> => {
  const modelId = aiModelsSchema.parse(modelName)
  const model = getAIModel({ type, authToken: apiKey, model: modelId })

  return generateTextAi({ model, prompt: messages, ...stripUnsupportedSamplingParams(modelId, restProps) })
}

type StreamText = Omit<Parameters<typeof streamTextAi>[0], 'model'> & {
  apiKey: string
  type: 'client' | 'server'
  modelName: string
}

export const streamText = ({
  apiKey,
  type = 'server',
  modelName,
  messages = [],
  ...restProps
}: StreamText): ReturnType<typeof streamTextAi> => {
  const modelId = aiModelsSchema.parse(modelName)
  const model = getAIModel({ type, authToken: apiKey, model: modelId })
  const prompt = messages ?? []
  return streamTextAi({ model, prompt, ...stripUnsupportedSamplingParams(modelId, restProps) })
}
